<template>
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">تماس با ما</h2>
            <h5 class="mt-3">
                در این بخش، به سوالات متداول شما درباره‌ی خدمات ناباکو و فرآیندهای سرمایه‌گذاری پاسخ می‌دهیم. هدف ما این است که با ارائه اطلاعات دقیق و کامل، ابهامات شما را برطرف کرده و مسیر سرمایه‌گذاری شما را هموارتر کنیم. اگر سوالات بیشتری دارید، لطفاً با ما تماس بگیرید
            </h5>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <div class="col-lg-6 text-end my-auto">
                        <div>
                            <FontAwesomeIcon icon="fa-solid fa-phone" class="fs-4"/>
                            <h5 class="d-inline me-3">پشتیبانی: <span>989192701407</span></h5>
                        </div>
                        <div class="my-3">
                            <FontAwesomeIcon icon="fa-solid fa-envelope" class="fs-4"/>
                            <h5 class="d-inline me-3">ایمیل: <span>info.nabacoai@gmail.com</span></h5>
                        </div>
                        <div class="my-3">
                            <FontAwesomeIcon icon="fa-solid fa-map-location-dot" class="fs-4"/>
                            <h5 class="d-inline me-3">آدرس: <span>تهران اقدسیه نرسیده به میدان اراج خیابان ابوالفضل صمیع پلاک 201 طبقه همکف</span></h5>
                        </div>
                    </div>
                    <div class="col-lg-6 my-auto text-end">
                        <googlemap></googlemap>
                        <div>
                            <h6 class="d-inline fw-bold">شبکه‌های اجتماعی ناباکو:</h6>
                            <div class="my-auto px-lg-3 px-0 d-inline mt-4">
                              <a class="footer-icon" href="https://t.me/XAIFIN"><FontAwesomeIcon icon="fa-brands fa-telegram"/></a>
                              <a class="mx-4 footer-icon" href="https://x.com/xaifin_ai"><FontAwesomeIcon icon="fa-brands fa-twitter"/></a>
                              <a class="footer-icon" href="https://www.instagram.com/nabaco.ai/"><FontAwesomeIcon icon="fa-brands fa-instagram"/></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faMapLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faTelegram, faTwitter } from '@fortawesome/free-brands-svg-icons';
import googlemap from '@/components/googlemap.vue';

 export default defineComponent({
    components:{FontAwesomeIcon,googlemap},
    setup() {
        library.add(faPhone,faEnvelope,faMapLocationDot,faTelegram,faTwitter,faInstagram)

        return {
        }
    }
 })
</script>

<style scoped>
.footer-icon {
  color: #004e9c;
  font-size: 25px
}
</style>